// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"3113":"6edf0643","9461":"41ade5dc"}[chunkId] || chunkId) + "." + {"12":"bea56ff653f4d066","3113":"0dad3cb654dcd3c8","9461":"dfdfb26541b41f1b"}[chunkId] + ".js";
};